import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { UIProvider, useUI } from './context/UIContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import LifeInsurance from './pages/LifeInsurance';
import HealthInsurance from './pages/HealthInsurance';
import MotorInsurance from './pages/MotorInsurance';
import PropertyInsurance from './pages/PropertyInsurance';
import TravelInsurance from './pages/TravelInsurance';
import BusinessInsurance from './pages/BusinessInsurance';
import Others from './pages/Others';
import ProductPage from './pages/ProductPage';
import Contact from './pages/Contact';
import About from './pages/About';
import Faqs from './pages/Faqs';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ScrollToTop from './components/ScrollToTop';
import EnquiryPopup from './components/EnquiryPopup';
import './App.css';

// Component to watch route changes and trigger popup
const RouteWatcher = () => {
  const { openPopup } = useUI();
  const location = useLocation();

  useEffect(() => {
    // Small delay for better UX after page load
    const timer = setTimeout(() => {
      openPopup();
    }, 2000);
    return () => clearTimeout(timer);
  }, [location.pathname, openPopup]);

  return null;
};

const AppContent = () => {
    const { isPopupOpen, closePopup } = useUI();
    
    return (
        <div className="App">
            <RouteWatcher />
            <Navbar />
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/faqs" element={<Faqs />} />
                    <Route path="/life-insurance" element={<LifeInsurance />} />
                    <Route path="/health-insurance" element={<HealthInsurance />} />
                    <Route path="/motor-insurance" element={<MotorInsurance />} />
                    <Route path="/property-insurance" element={<PropertyInsurance />} />
                    <Route path="/travel-insurance" element={<TravelInsurance />} />
                    <Route path="/business-insurance" element={<BusinessInsurance />} />
                    <Route path="/others" element={<Others />} />
                    <Route path="/insurance/:productId" element={<ProductPage />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                </Routes>
            </main>
            <Footer />
            <EnquiryPopup isOpen={isPopupOpen} onClose={closePopup} />
        </div>
    );
};

function App() {
  return (
    <LanguageProvider>
      <UIProvider>
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      </UIProvider>
    </LanguageProvider>
  );
}

export default App;
